import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessagingService } from '../../../services/messaging.service';
import {Globals} from '../../../globals';
import {MessagingConstants} from '../../../models/MessagingConstants';
import {PatientCaseWorkItemFormDataModel} from '../../../models/forms/data/patient-case-work-item-form-data.model';
import {DataPatientCaseWorkItemModel} from '../../../models/accountsReceivable/data-patient-case-work-item.model';

@Component({
  selector: 'app-case-form-view',
  templateUrl: './case-form-view.component.html',
  styleUrls: ['./case-form-view.component.css']
})
export class CaseFormViewComponent implements OnInit, OnDestroy {
  currentEnumCustomFormID: string;
  currentCaseWorkItemFormsId: string;
  currentCaseId: string;
  messageSubscription: any;
  currentCaseWorkItemForm: PatientCaseWorkItemFormDataModel;
  currentCaseWorkItem: DataPatientCaseWorkItemModel;
  currentTreatmentPlanId:string;
  currentToothId: string;

  // Forms
  /////////////////////////////////////////////////////////////////////
  customFormPerio             = '00000039-1000-0000-0000-000000000001';
  customFormTreatment         = '00000039-1000-0000-0000-000000000003';
  customFormFinalReport       = '00000039-1000-0000-0000-000000000006';
  customFormTreatmentPlanning = '00000039-1000-0000-0000-000000000007';
  customFormRecall            = '00000039-1000-0000-0000-000000000008';
  customFormMti               = '00000039-1000-0000-0000-000000000009';
  customFormDiagnosis         = '00000039-1000-0000-0000-000000000010';
  customFormTreatmentPlanApproval = '00000039-1000-0000-0000-000000000011';
  customFormSurgicalDiagnosis   = '00000039-1000-0000-0000-000000000012';
  customFormSurgicalTreatment   = '00000039-1000-0000-0000-000000000013';

  constructor(private readonly messagingService: MessagingService,
              public globals: Globals) { }
              
  ngOnDestroy(): void {
    if (this.messageSubscription)
      this.messageSubscription.unsubscribe();
  }

  ngOnInit() {
    this.messageSubscription = this.messagingService.componentMessageCall.subscribe(response => {

      if (response.event === MessagingConstants.FORM_EDIT_START) {
        this.currentCaseId = this.globals.currentPatientCaseId;
        console.log('CaseFormViewComponent FORM_EDIT_START response.data: ', response.data);
        if (response.data) {
          this.currentTreatmentPlanId = undefined;
          this.currentCaseWorkItemFormsId = undefined;
          this.currentEnumCustomFormID = undefined;
          this.currentCaseWorkItemForm = undefined;
          this.currentCaseWorkItem = undefined;
          this.currentToothId = undefined;

          setTimeout(() => {
            this.currentCaseWorkItem = response.data.caseWorkItem;
            this.currentCaseWorkItemFormsId = response.data.CaseWorkItemFormsId;
            if (this.currentCaseWorkItemFormsId) {
              this.globals.currentPatientCaseWorkItemFormsID = this.currentCaseWorkItemFormsId;
            }
            
            this.currentTreatmentPlanId = response.data.TreatmentPlanId;
            if (this.currentTreatmentPlanId) {
              this.globals.currentTreatmentPlanID = this.currentTreatmentPlanId;
            }
            this.currentEnumCustomFormID = response.data.enumCustomFormId;
            this.currentCaseWorkItemForm = response.data.form;
            this.currentToothId = this.currentCaseWorkItem?.dataPatientCaseItemTeeth[0]?.ToothID;
          }, 20);
        }
      }

      if (response.event === MessagingConstants.CASE_CHANGED_EVENT) {
        console.log('CaseFormViewComponent CASE_CHANGED_EVENT', response.data);
        this.currentCaseWorkItemFormsId = null;
        this.globals.currentPatientCaseWorkItemFormsID = this.currentCaseWorkItemFormsId;
        if(localStorage.getItem('isSelectedMTI') !== 'true') {
          this.currentEnumCustomFormID = null;
        }
      }
    });
  }
}
